import { render } from "./NotificationsView.vue?vue&type=template&id=28882b12&scoped=true&ts=true"
import script from "./NotificationsView.vue?vue&type=script&lang=ts"
export * from "./NotificationsView.vue?vue&type=script&lang=ts"

import "./NotificationsView.vue?vue&type=style&index=0&id=28882b12&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28882b12"]])

export default __exports__